module.exports = __webpack_public_path__ + "img/location-green.53aa3dba.svg";